import { render, staticRenderFns } from "./PT502GTMViewItem.vue?vue&type=template&id=fbb7498a&"
import script from "./PT502GTMViewItem.vue?vue&type=script&lang=js&"
export * from "./PT502GTMViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports